<template>
  <div class="f360-callout">
    <h4>
      A franqueadora abaixo possui pendência na parametrização do De-Para:
    </h4>
    <ul class="f360-callout__list">
      <li v-for="franqueador in lista" :key="franqueador.nome">
        {{ franqueador.nome }}
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
type Props = {
  data: string[];
}
import { computed } from 'vue'
const props = defineProps<Props>();
const lista = computed(() =>
  props.data.map((nome, index) => ({ nome, index }))
);
</script>

<style lang="scss">
.f360-callout {
  width: auto;
  display: flex;
  flex-direction: column;
  padding: 0 1rem 0;
  background-color: #fcf2f2;
  border-left: 5px solid #dfb5b4;
  font-family: "Plus Jakarta Sans", sans-serif;
  margin: 10px 0;

  h4 {
    margin: 10px 0 10px;
  }

  &__list {
    list-style: none;
    padding: 0;
    margin: 0px 0 10px;
    font-size: 14px;
    gap: 5px;
    line-height: 1.5;
    width: fit-content;

    li {
      color: #2e2e2e;
    }

    li:hover {
      color: #6f9db9;
      cursor: pointer;
    }
  }

  h4 {
    color: #b94a48;
  }

  p {
    font-size: 14px;
    color: #2e2e2e;
  }
}
</style>
